var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.962627 5.08044C0.739398 5.14422 0.536693 5.26518 0.374567 5.43136C0.212442 5.59754 0.0965169 5.80317 0.0382623 6.0279C-0.0199922 6.25264 -0.018557 6.48869 0.0424261 6.7127C0.103409 6.93671 0.221826 7.14091 0.38596 7.3051L2.66063 9.5771V13.9678H7.05596L9.34596 16.2544C9.46878 16.3785 9.61497 16.4771 9.77608 16.5443C9.93719 16.6116 10.11 16.6463 10.2846 16.6464C10.3994 16.6462 10.5136 16.6314 10.6246 16.6024C10.8493 16.5459 11.055 16.4311 11.2212 16.2697C11.3874 16.1083 11.5082 15.906 11.5713 15.6831L15.994 0.648438L0.962627 5.08044ZM1.33329 6.36244L12.6853 3.01577L3.99529 11.6918V9.0251L1.33329 6.36244ZM10.2933 15.3118L7.60863 12.6344H4.94196L13.6306 3.9531L10.2933 15.3118Z",
    fill: "#5D84C1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send_icon.41c5eb0a6b4afafe1f61f00dd741ac23.svg";
export { ForwardRef as ReactComponent };